import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { PictureLoadMethod, PictureObjectFit } from '@freelancer/ui/picture';

@Component({
  standalone: false,
  selector: 'app-company-logo',
  template: `
    <div class="CompanyLogo">
      <fl-picture
        class="CompanyLogo-image"
        [class.CompanyLogo-image--redesign]="isRedesign"
        [alt]="alt"
        [boundedWidth]="true"
        [boundedHeight]="true"
        [loadMethod]="PictureLoadMethod.LAZY"
        [objectFit]="PictureObjectFit.SCALE_DOWN"
        [src]="src"
        [width]="explicitWidth"
        [height]="explicitHeight"
      ></fl-picture>
    </div>
  `,
  styleUrls: ['./company-logo.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CompanyLogoComponent {
  PictureObjectFit = PictureObjectFit;
  PictureLoadMethod = PictureLoadMethod;

  @Input() alt: string;
  @Input() src: string;
  @Input() explicitHeight: number;
  @Input() explicitWidth: number;
  @Input() isRedesign: boolean;
}
